module.exports = __webpack_public_path__ + "img/yyzz2.2bc513c9.png";